var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataFrameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 61,
    viewBox: "0 0 63 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7305 30.7203H25.1305M28.3305 37.1203H25.1305M37.9305 24.3203H25.1305M44.3305 24.0003V40.6403C44.3305 43.3286 44.3305 44.6727 43.8073 45.6995C43.3471 46.6026 42.6128 47.337 41.7096 47.7971C40.6828 48.3203 39.3387 48.3203 36.6505 48.3203H26.4105C23.7222 48.3203 22.3781 48.3203 21.3513 47.7971C20.4481 47.337 19.7138 46.6026 19.2536 45.6995C18.7305 44.6727 18.7305 43.3286 18.7305 40.6403V24.0003C18.7305 21.3121 18.7305 19.9679 19.2536 18.9412C19.7138 18.038 20.4481 17.3037 21.3513 16.8435C22.3781 16.3203 23.7222 16.3203 26.4105 16.3203H36.6505C39.3387 16.3203 40.6828 16.3203 41.7096 16.8435C42.6128 17.3037 43.3471 18.038 43.8073 18.9412C44.3305 19.9679 44.3305 21.3121 44.3305 24.0003Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFrameIcon);
export default __webpack_public_path__ + "static/media/data-frame-icon.6ff56ea5c864dfc15324d1c255356a83.svg";
export { ForwardRef as ReactComponent };